export function isMobileDynamic() {
  return window.innerWidth <= 768;
}
